import React, { useEffect, useState } from 'react';
import { adminApi } from '../../api/client';
import Modal from '../../components/common/Modal';
import Spinner from '../../components/common/Spinner';
import { FaPlus, FaMoneyBill } from 'react-icons/fa';
import toast from 'react-hot-toast';

export default function Fees() {
  const [tab,       setTab]       = useState('structures');
  const [fees,      setFees]      = useState([]);
  const [outstanding, setOutstanding] = useState([]);
  const [grades,    setGrades]    = useState([]);
  const [terms,     setTerms]     = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [modal,     setModal]     = useState(false);
  const [form,      setForm]      = useState({ name:'', amount:'', grade_id:'', term_id:'', due_date:'' });

  const load = () => {
    Promise.all([adminApi.getFeeStructures(), adminApi.getGrades(), adminApi.getTerms(), adminApi.getOutstanding()])
      .then(([f, g, t, o]) => { setFees(f.data.data); setGrades(g.data.data); setTerms(t.data.data); setOutstanding(o.data.data); })
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    try { await adminApi.addFeeStructure(form); toast.success('Fee added'); setModal(false); load(); }
    catch (err) { toast.error(err.response?.data?.message || 'Failed'); }
  };

  return (
    <div>
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div><h2>Fees Management</h2><p>Track school fees and payments</p></div>
        <button className="sms-btn sms-btn-primary" onClick={() => { setForm({ name:'',amount:'',grade_id:'',term_id:'',due_date:'' }); setModal(true); }}><FaPlus size={13} /> Add Fee</button>
      </div>

      <div style={{ display: 'flex', gap: 4, marginBottom: 20, background: '#f3f4f6', borderRadius: 10, padding: 4, width: 'fit-content' }}>
        {[['structures','Fee Structures'],['outstanding','Outstanding']].map(([k,l]) => (
          <button key={k} onClick={() => setTab(k)} className="sms-btn" style={{ background: tab===k ? '#fff' : 'transparent', boxShadow: tab===k ? '0 1px 4px rgba(0,0,0,0.1)' : 'none', color: tab===k ? '#111' : '#6b7280', padding: '7px 18px', borderRadius: 8 }}>{l}</button>
        ))}
      </div>

      {loading ? <Spinner /> : tab === 'structures' ? (
        <div className="sms-card" style={{ padding: 0, overflow: 'hidden' }}>
          <table className="sms-table">
            <thead><tr><th>Fee Name</th><th>Amount</th><th>Grade</th><th>Term</th><th>Due Date</th></tr></thead>
            <tbody>
              {fees.map(f => (
                <tr key={f.id}>
                  <td style={{ fontWeight: 500 }}>{f.name}</td>
                  <td>R {parseFloat(f.amount).toFixed(2)}</td>
                  <td>{f.grade_number || 'All'}</td>
                  <td>{f.term_name || 'All Terms'}</td>
                  <td>{f.due_date || '—'}</td>
                </tr>
              ))}
              {fees.length === 0 && <tr><td colSpan="5" style={{ textAlign:'center', color:'#9ca3af', padding:'40px 0' }}>No fee structures</td></tr>}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="sms-card" style={{ padding: 0, overflow: 'hidden' }}>
          <table className="sms-table">
            <thead><tr><th>Learner</th><th>Grade</th><th>Fee</th><th>Amount</th><th>Paid</th><th>Outstanding</th><th>Due</th></tr></thead>
            <tbody>
              {outstanding.map((o, i) => (
                <tr key={i}>
                  <td style={{ fontWeight: 500 }}>{o.learner_name}</td>
                  <td>{o.grade_number}</td>
                  <td>{o.fee_name}</td>
                  <td>R {parseFloat(o.fee_amount).toFixed(2)}</td>
                  <td style={{ color: '#10b981' }}>R {parseFloat(o.paid).toFixed(2)}</td>
                  <td style={{ color: '#ef4444', fontWeight: 600 }}>R {parseFloat(o.outstanding).toFixed(2)}</td>
                  <td style={{ color: new Date(o.due_date) < new Date() ? '#ef4444' : '#6b7280' }}>{o.due_date || '—'}</td>
                </tr>
              ))}
              {outstanding.length === 0 && <tr><td colSpan="7" style={{ textAlign:'center', color:'#9ca3af', padding:'40px 0' }}>No outstanding fees 🎉</td></tr>}
            </tbody>
          </table>
        </div>
      )}

      <Modal show={modal} onClose={() => setModal(false)} title="Add Fee Structure">
        <form onSubmit={handleSave}>
          {[['Fee Name','name',true],['Amount (R)','amount',true]].map(([l,k,r]) => (
            <div key={k} style={{ marginBottom: 14 }}>
              <label className="sms-label">{l}{r&&<span style={{color:'#ef4444'}}>*</span>}</label>
              <input className="sms-input" type={k==='amount'?'number':'text'} step={k==='amount'?'0.01':undefined} value={form[k]} onChange={e=>setForm({...form,[k]:e.target.value})} required={!!r} />
            </div>
          ))}
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:14 }}>
            <div><label className="sms-label">Grade (leave blank = all)</label>
              <select className="sms-input" value={form.grade_id} onChange={e=>setForm({...form,grade_id:e.target.value})}>
                <option value="">All Grades</option>
                {grades.map(g=><option key={g.grade_id} value={g.grade_id}>Grade {g.grade_number}</option>)}
              </select>
            </div>
            <div><label className="sms-label">Term</label>
              <select className="sms-input" value={form.term_id} onChange={e=>setForm({...form,term_id:e.target.value})}>
                <option value="">All Terms</option>
                {terms.map(t=><option key={t.term_id} value={t.term_id}>{t.name} {t.year}</option>)}
              </select>
            </div>
          </div>
          <div style={{ marginBottom:20 }}><label className="sms-label">Due Date</label><input className="sms-input" type="date" value={form.due_date} onChange={e=>setForm({...form,due_date:e.target.value})} /></div>
          <div style={{ display:'flex', gap:10 }}>
            <button type="submit" className="sms-btn sms-btn-primary">Save</button>
            <button type="button" className="sms-btn sms-btn-outline" onClick={()=>setModal(false)}>Cancel</button>
          </div>
        </form>
      </Modal>
    </div>
  );
}
